module.exports = __webpack_public_path__ + "img/icon-tooltip.5b5a8380.svg";